import * as MaterialDesignIcons from "react-icons/md";
import * as FontAwesomeIcons from "react-icons/fa";

export function DynamicIcon({iconLibrary, iconName, size = 35}) {
    const libraries = {
        materialDesign: {
            prefix: "Md",
            icons: MaterialDesignIcons,
        },
        fontAwesome: {
            prefix: "Fa",
            icons: FontAwesomeIcons,
        },
    };

    const selectedLibrary = libraries[iconLibrary];

    if (!selectedLibrary || !iconName) {
        const ErrorIcon = MaterialDesignIcons.MdError;
        return (
            <span style={{color: "red"}}>
                <ErrorIcon size={size} />
            </span>
        );
    }

    const fullIconName = `${selectedLibrary.prefix}${iconName}`;
    const IconComponent = selectedLibrary.icons[fullIconName];

    if (!IconComponent) {
        const ErrorIcon = MaterialDesignIcons.MdError;
        return <ErrorIcon size={size} />;
    }

    return <IconComponent style={{width: size, height: size, flexShrink: 0}} />;
}
